<template>
  <div>
    <unicom-importar-v3
      textoInformativo="Arraste e solte o arquivo com a justificativa aqui."
      :styleImportacao="{ height: '250px' }"
      :extensoesPermitidas="extensoesPermitidas"
      :extensoesPermitidasLogica="extensoesPermitidasLogica"
      :tamanhoDoArquivoPermitido="20"
      @erro-arquivo="erroArquivo"
      @arquivo-recebido="arquivoRecido"
    />
  </div>
</template>

<script>
const aceitaZip = ".zip,.rar,.7zip";

const aceitaZipArr = [".zip", ".rar", ".7zip"];

export default {
  methods: {
    arquivoRecido(file) {
      this.$emit("arquivo", file);
    },
    erroArquivo(objetoErro) {
      const { extensao, mensagemErro } = objetoErro;

      if (extensao) {
        this.$store.commit("setErro", {
          mostrarErro: true,
          titulo: "Oops, algo deu errado.",
          codigoErro: 422,
          mensagemErro: this.mensagemErroExtensao
        });
        return;
      }

      this.$store.commit("setErro", {
        mostrarErro: true,
        titulo: "Oops, algo deu errado.",
        codigoErro: 422,
        mensagemErro
      });
    }
  },
  computed: {
    extensoesPermitidas() {
      return `${aceitaZip}`;
    },
    mensagemErroExtensao() {
      return `Somente são permitidos arquivos com as extensões ( ${this.extensoesPermitidasLogica.join(
        ", "
      )} )`;
    },
    extensoesPermitidasLogica() {
      return [...aceitaZipArr];
    }
  }
};
</script>

<style></style>
